var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page", attrs: { id: "About", "data-page": "faq" } },
    [
      _c("appModal", {
        ref: "appModalRef",
        attrs: { countries: _vm.DBCountries }
      }),
      _c("appHeader", {
        attrs: { bgColor: "blue", page: "about" },
        on: { headerMenuClicked: _vm.menuClicked }
      }),
      _vm._m(0),
      _c("appFooter"),
      _c("cookiesConsent")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "main" }, [
      _c("div", { staticClass: "main_inner" }, [
        _c("section", { staticClass: "main_section" }, [
          _c("div", { staticClass: "section_content" }, [
            _c("h1", { staticClass: "title_page text_title2" }, [
              _vm._v("\n                        FAQ\n                    ")
            ])
          ])
        ]),
        _c("section", { staticClass: "main_section section_about" }, [
          _c("div", { staticClass: "section_content" }, [
            _c("div", { staticClass: "content_title" }, [
              _vm._v("1. What is the Atlas of the Offshore World?")
            ]),
            _c("p", { staticClass: "text_p" }, [
              _vm._v(
                "The Atlas of the Offshore World is a global repository developed by the EU Tax Observatory and Skatteforsk – Centre for Tax Research. It provides research-based, reliable, up-to-date, and user-friendly information on global profit shifting, offshore financial and real estate wealth, and effective tax rates worldwide."
              )
            ]),
            _c("p", { staticClass: "text_p" }, [
              _vm._v(
                "The Atlas aims to facilitate and promote democratic dialogue on global tax avoidance by providing detailed and accessible information. It serves as a tool for researchers, policymakers, and civil society to understand and address issues related to tax evasion and avoidance."
              )
            ]),
            _c("p", { staticClass: "text_p" }, [
              _vm._v(
                "The Atlas is a joint initiative by the EU Tax Observatory and Skatteforsk – Centre for Tax Research, with financial support from Norway. It aims to inform scientific communities, civil society, and policymakers about global tax avoidance."
              )
            ]),
            _c("br"),
            _c("br"),
            _c("div", { staticClass: "content_title" }, [
              _vm._v(
                "2. How reliable is the data in the Atlas, and what methodologies are used?"
              )
            ]),
            _c("p", { staticClass: "text_p" }, [
              _vm._v(
                "The data provided in the Atlas of the Offshore World is based on peer-reviewed academic research and official statistics from credible sources such as the OECD, national tax authorities, and international financial databases."
              )
            ]),
            _c("p", { staticClass: "text_p" }, [
              _vm._v(
                'Each dataset is accompanied by detailed methodological notes that explain the assumptions, data sources, and calculation techniques used. These notes aim to ensure transparency, reproducibility, and scholarly rigor. Users can review and download these documents from the "Download data & methodology" section of the website.'
              )
            ]),
            _c("p", { staticClass: "text_p" }, [
              _vm._v(
                "While efforts are made to ensure accuracy, the Atlas acknowledges limitations due to data availability and possible underreporting in offshore activities. Nonetheless, the methodologies used are considered state-of-the-art in the field of international tax research."
              )
            ]),
            _c("br"),
            _c("br"),
            _c("div", { staticClass: "content_title" }, [
              _vm._v("3. How often is the data updated?")
            ]),
            _c("p", { staticClass: "text_p" }, [
              _vm._v(
                "The datasets are periodically updated to reflect the most recent data and research findings. The last update was 14 November 2025"
              )
            ]),
            _c("br"),
            _c("br"),
            _c("div", { staticClass: "content_title" }, [
              _vm._v("4. Can I download the data and methodology?")
            ]),
            _c("p", { staticClass: "text_p" }, [
              _vm._v(
                'Yes, the Atlas provides complete annotated versions of the datasets along with detailed methodology notes for each series. These can be accessed and downloaded from the "Download data & methodology" section on the website.'
              )
            ]),
            _c("br"),
            _c("br"),
            _c("div", { staticClass: "content_title" }, [
              _vm._v(
                "5. Is there a way to engage with the Atlas team for questions or feedback?"
              )
            ]),
            _c("p", { staticClass: "text_p" }, [
              _vm._v("Yes, you can send an email to "),
              _c(
                "a",
                { attrs: { href: "mailto:info@atlas-offshore-world.org" } },
                [_vm._v("info@atlas-offshore-world.org")]
              ),
              _vm._v(" with your query. The Atlas team will get in touch soon.")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-237aa020", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-237aa020","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/faq/index.vue
// module id = 1eZF
// module chunks = 5